import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TermsOfUse from '../../assets/docs/PolyBetTOS.pdf';

const Footer = ({ bgColor }) => {
  return (
    <SectionFooter bgColor={bgColor}>
      <FooterInner>
        <Socials>
          <SocialLink href="https://x.com/polybet" target="_blank" rel="noopener noreferrer" aria-label="X">
            <img src="/x-logo.png" alt="X" />
          </SocialLink>
          <SocialIcon aria-label="Discord">
            <img src="/discord-logo.svg" alt="Discord" />
          </SocialIcon>
        </Socials>

        <TermsLink href={TermsOfUse} target="_blank" rel="noopener noreferrer">
          PolyBet Terms and Conditions
        </TermsLink>
      </FooterInner>
    </SectionFooter>
  );
};

export default Footer;

Footer.propTypes = {
  bgColor: PropTypes.string,
  paddingBottom: PropTypes.number,
  paddingTop: PropTypes.number,
};

Footer.defaultProps = {
  bgColor: 'transparent',
  paddingBottom: 0,
  paddingTop: 0,
};

const SectionFooter = styled.footer`
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: ${({ bgColor }) => bgColor || 'transparent'};
  padding: 30px 20px 36px;
`;

const FooterInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  text-align: center;
`;

const Socials = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
`;

const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  &:first-child img {
    filter: invert(1);
  }
`;

const SocialIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
`;

const TermsLink = styled.a`
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: #f8fafc;
    text-decoration: none;
  }
`;
